import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  ButtonIcon,
  Dropdown,
  Text,
} from '@quintoandar-tokko/jopijs';
import styles from '../filterBar.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '../FilterBar.trans.json';
import { normalizeText, formatSelectedText } from '../utils';
import { TAG, TAG_LABEL_KEY } from '../constants/filtersConstants';
import { setSelectedIds } from '@/store/slices/components/filterBar/FilterBarSlice';
import FilterSelectControl, {
  useFilterSelection,
} from '../FilterSelectControl';
import { getTags } from '@/store/slices/components/filterBar/service';

function TagsDropdown() {
  const dispatch = useDispatch();
  const { selectedIds, tags } = useSelector(
    (state) => state.FilterBarSlice.filters
  );
  const [selectedLocalIds, setSelectedLocalIds] = useState([]);
  const [searchText, setSearchText] = useState('');

  const tagTitle = Trans(translations, 'Tags');
  const normalizedSearch = normalizeText(searchText);

  useEffect(() => {
    dispatch(getTags());
  }, []);

  const filteredTags = tags.filter((tag) =>
    normalizeText(tag[TAG_LABEL_KEY]).includes(normalizedSearch)
  );

  const toggleSelection = (tag) => {
    setSelectedLocalIds((prev) => {
      const isSelected = prev.find((x) => x.id === tag.id);
      if (isSelected) {
        return prev.filter((x) => x.id !== tag.id);
      }
      return [...prev, { id: tag.id, text: tag.name, filter_type: TAG }];
    });
  };

  const valueTextButton = formatSelectedText(selectedIds, tagTitle, TAG);

  const handleTagAdd = () => {
    dispatch(setSelectedIds({ idList: selectedLocalIds, type: TAG }));
  };

  useEffect(() => {
    const tagsSelec = selectedIds.filter((id) => id.filter_type === TAG);
    return setSelectedLocalIds(tagsSelec);
  }, [selectedIds]);

  const selection = useFilterSelection(TAG);

  return (
    <Dropdown height="auto" className={`dropdown ${styles.dropdownList}`}>
      <FilterSelectControl
        filled={selection.filled}
        pending={selectedLocalIds.length > 0}
        tooltip={selection.tooltip}
        onClear={selection.onClear}
        clearLabel={selection.clearLabel}
      >
        <Dropdown.Button
          variant="dropdownDefault"
          className={styles.dropdownButton}
          text={valueTextButton}
        />
      </FilterSelectControl>
      <Dropdown.Items height={336} clickClose className={styles.dropdownItems}>
        <Dropdown.Search
          placeholder={Trans(translations, 'SearchTags')}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          suffix={
            searchText !== '' && (
              <ButtonIcon
                variant={['transparentIcon', 'iconExtraSmall22px']}
                icon="icon-cerrar"
                onClick={(e) => {
                  e.stopPropagation();
                  setSearchText('');
                }}
              />
            )
          }
        />
        {filteredTags.map((tag, index) => {
          const prevTag = filteredTags[index - 1];
          const currentGroup = tag.group || Trans(translations, 'WithoutGroup');
          const prevGroup =
            prevTag?.group ||
            (prevTag ? Trans(translations, 'WithoutGroup') : null);

          const showGroupTitle = currentGroup !== prevGroup;
          return (
            <Box key={tag.id}>
              {showGroupTitle && (
                <Text className={styles.groupTitle}>{currentGroup}</Text>
              )}
              <Dropdown.Multiselect
                onClick={(e) => {
                  e.stopPropagation();
                  toggleSelection(tag);
                }}
                active={selectedLocalIds.find((x) => x.id === tag.id)}
                className={styles.dropdownMultiselect}
              >
                {tag.name}
              </Dropdown.Multiselect>
            </Box>
          );
        })}
        {filteredTags.length === 0 && (
          <Dropdown.Text>{Trans(translations, 'NoResultsFound')}</Dropdown.Text>
        )}
        <Box className={styles.applyButtonContainer}>
          <Button
            className={styles.applyButton}
            variant={['primary', 'small']}
            onClick={handleTagAdd}
          >
            {Trans(translations, 'Apply')}
          </Button>
        </Box>
      </Dropdown.Items>
    </Dropdown>
  );
}

export default TagsDropdown;
